"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FormPicker_1 = require("./FormPicker");

exports.FormPicker = FormPicker_1.default;
exports.FormPickerComponent = FormPicker_1.FormPicker;